import React from "react"
import styled from "styled-components"
import { FaTimes } from "react-icons/fa"
import { Link as LinkS } from "react-scroll"
import "@fontsource/encode-sans-expanded"
import { Link } from "gatsby"

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <ClosedIcon />
      </Icon>
      <Wrapper>
        <Menu>
          <SidebarLink
            to="about"
            smooth={true}
            duration={1500}
            spy={true}
            exact="true"
            onClick={toggle}
          >
            About
          </SidebarLink>
          <SidebarLink
            to="featuresstart"
            smooth={true}
            duration={1500}
            spy={true}
            exact="true"
            offset={-80}
            onClick={toggle}
          >
            Features
          </SidebarLink>
          <SidebarLink
            to="updates"
            smooth={true}
            duration={1500}
            spy={true}
            exact="true"
            offset={-80}
            onClick={toggle}
          >
            Updates
          </SidebarLink>
          <SidebarLink
            to="partners"
            smooth={true}
            duration={1500}
            spy={true}
            exact="true"
            offset={-80}
            onClick={toggle}
          >
            Partners
          </SidebarLink>

          <SidebarLink2 to="/careers">Careers</SidebarLink2>

          <SidebarLink2 to="/contact">Contact Us</SidebarLink2>
        </Menu>
      </Wrapper>
    </SidebarContainer>
  )
}

export default Sidebar

const SidebarContainer = styled.aside`
  display: none;

  @media screen and (max-width: 900px) {
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: #1b2227;
    display: grid;
    align-items: center;
    top: 0;
    left: 0;
    transition: 0.3s ease-in-out;
    opacity: ${({ isOpen }) => (isOpen ? "100%" : "0%")};
    top: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
    color: #fabf49;
  }
`

const ClosedIcon = styled(FaTimes)`
  color: #fabf49;
`

const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  background: transparent;
  font-size: 2rem;
  cursor: pointer;
  outline: none;
`

const Wrapper = styled.div`
  color: #fabf49;
`

const SidebarLink = styled(LinkS)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: #fabf49;
  cursor: pointer;
  font-family: "Encode Sans Expanded", sans-serif;

  &:hover {
    color: white;
    transition: 0.2s ease-in-out;
  }
`

const Menu = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 80px);
  text-align: center;

  @media screen and (max-width: 480px) {
    grid-template-rows: repeat(6, 60px);
  }
`

const SidebarLink2 = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: #fabf49;
  cursor: pointer;
  font-family: "Encode Sans Expanded", sans-serif;

  &:hover {
    color: white;
    transition: 0.2s ease-in-out;
  }
`
